import type { ReactNode } from 'react';
import type { LayerSection } from 'features/mapping/mapping.types';

import { LayersSection } from './LayersSection';

export type LayerGroupsSectionProps = {
  section: LayerSection;
  title: string;
  expanded: boolean;
  onToggleCollapse: () => void;
  children: ReactNode;
};

export const LayerGroupsSection = (
  props: LayerGroupsSectionProps,
): JSX.Element => {
  const { section, title, expanded, onToggleCollapse, children } = props;

  return (
    <LayersSection
      section={section}
      title={title}
      expanded={expanded}
      onToggleCollapse={onToggleCollapse}
      listProps={{ disablePadding: true }}
    >
      {children}
    </LayersSection>
  );
};
